import Typography from '@mui/material/Typography';

import type { ExternalReferenceTypeId } from '@e-socna/data-layer';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { externalReferencesLabelOf } from './utils/external-references-label.util';

interface Props {
  readonly references: readonly Readonly<{ typeId: string; value: string }>[];
}

// The references an actor gives the entity, on its card: none for an internal actor.
export const ExternalReferencesSection = ({ references }: Readonly<Props>) => {
  const { externalReferenceTypesIdMap } = useReferencesContext();

  if (!references.length) {
    return null;
  }

  return (
    <>
      <Typography color="text.secondary" variant="overline">
        Références
      </Typography>
      <Typography gutterBottom variant="body2">
        {externalReferencesLabelOf(
          references,
          (typeId) =>
            externalReferenceTypesIdMap[typeId as ExternalReferenceTypeId]
              ?.label ?? 'Inconnue',
        )}
      </Typography>
    </>
  );
};
